"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _reactComponents = require("@ui-propulsion/react-components");
require("./styles.scss");
var InfoDetailSection = function InfoDetailSection(_ref) {
  var label = _ref.label,
    detail = _ref.detail;
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "info-detail__section"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "info-detail__label",
    "data-test-id": "info-label"
  }, ' ', label, ' ')), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "info-detail__label--strong",
    "data-test-id": "info-value"
  }, ' ', detail, ' '))));
};
InfoDetailSection.propTypes = {
  label: _propTypes.string.isRequired,
  detail: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element]).isRequired
};
var _default = InfoDetailSection;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/@pf-loan-funnel/pf-refunds/lib/components/InfoDetailSection/styles.scss');